$(document).ready(function () {

  var htmlElement = $("html");
  

  function checkScroll(){

    if ($(window).scrollTop() >= 1) {
      htmlElement.addClass('scrolled');
    } else {
      htmlElement.removeClass('scrolled');
    }
  }
  checkScroll();
  $(window).scroll(checkScroll);



  setTimeout(function(){
    $("#preloader-container").fadeOut(800, function() { $(this).remove(); });
  }, 2500);


  if ( $('.announcement-bar').length != 0 ) {
    htmlElement.addClass('has-announcement-bar');
  }



  var noteMaxLength = setInterval(myTimer, 3000);
  function myTimer() {
    if ( $('#slidecarthq').find('.note-body textarea').length != 0 ) {
      $('#slidecarthq').find('.note-body textarea').attr('maxlength','150');
      // can't stop it because each time the note is removed and added it's max length needs to be set
      // myStopFunction();
    }
  }
  function myStopFunction() {
    clearInterval(noteMaxLength);
  }



  /******************
  COOKIE NOTICE
  ******************/
  if(getCookie('show_cookie_message') != 'no') {
      $('#cookie_box').show();
  }
  $('.cookie_box_close').click(function() {
      $('#cookie_box').remove();
      setCookie('show_cookie_message','no');
      return false;
  });
  function setCookie(cookie_name, value) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + (365*25));
      document.cookie = cookie_name + "=" + escape(value) + "; expires="+exdate.toUTCString() + "; path=/";
  };
  function getCookie(cookie_name) {
      if (document.cookie.length>0)
      {
          cookie_start = document.cookie.indexOf(cookie_name + "=");
          if (cookie_start != -1)
          {
              cookie_start = cookie_start + cookie_name.length+1;
              cookie_end = document.cookie.indexOf(";",cookie_start);
              if (cookie_end == -1)
              {
                  cookie_end = document.cookie.length;
              }
              return unescape(document.cookie.substring(cookie_start,cookie_end));
          }
      }
      return "";
  };

  window.SLIDECART_OPENED = function(cart) {
    if ( $('#slidecarthq .slidecarthq .items .continue-shopping').length == 0 ) {
      $('#slidecarthq .slidecarthq .items').append('<a class="continue-shopping" href="/collections/all">Continue Shopping</a>');
    }
  }

  // Check if qualifying item is in cart to show gift upsell
  window.SLIDECART_UPDATED = function(cart) {
    showUpsell();
  };
  function showUpsell() {
      $.ajax({
              type: 'GET',
              url: '/cart.js',
              data: $(this).serialize(),
              dataType: 'json',
              success: function (data) {
                  var inCart = false;
                  $.each(data.items, function(index, cartItem) {
                    // this list of product ids must also be listed in the theme.liquid file
                    if ( cartItem.product_id == 5765865865381 || cartItem.product_id == 5765865799845 ) {
                      inCart = true;
                      return false;
                    }
                  });
                  if ( inCart ) {
                    htmlElement.addClass('show-upsell');
                  } else {
                    htmlElement.removeClass('show-upsell');
                  }
              }
      });
  };


});